// extracted by mini-css-extract-plugin
module.exports = {"dashboardSections":"dashboard-overview_dashboardSections__lVmUO","bannerFirst":"dashboard-overview_bannerFirst__YZKnK","bannerLast":"dashboard-overview_bannerLast__SzDoy"};